import React from 'react';
import { Card, CardHeader, CardTitle, CardContent } from '../ui/card';
import { ChevronRight } from 'lucide-react';

export default function ActivityList({ title, items, color = 'blue' }) {
  const dotColors = {
    blue: 'bg-blue-500',
    green: 'bg-green-500',
    orange: 'bg-orange-500',
    red: 'bg-red-500',
    purple: 'bg-purple-500'
  };

  return (
    <Card className="shadow-sm border border-gray-200">
      <CardHeader className="pb-3">
        <CardTitle className="text-base font-semibold text-gray-800">{title}</CardTitle>
      </CardHeader>
      <CardContent className="space-y-1">
        {items && items.length > 0 ? (
          items.map((item, index) => (
            <div 
              key={index}
              className="flex items-center justify-between py-2 px-3 rounded-md hover:bg-gray-50 transition-colors cursor-pointer group"
            >
              <div className="flex items-center space-x-3">
                <div className={`w-2 h-2 rounded-full ${dotColors[item.color || color]}`}></div>
                <span className="text-sm text-gray-700">{item.label}</span>
              </div>
              <div className="flex items-center space-x-2">
                <span className="text-sm font-semibold text-gray-900">{item.value}</span>
                <ChevronRight className="w-4 h-4 text-gray-400 opacity-0 group-hover:opacity-100 transition-opacity" />
              </div>
            </div>
          ))
        ) : (
          <div className="text-sm text-gray-500 text-center py-6">No data available</div>
        )}
      </CardContent>
    </Card>
  );
}